function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import Measure from "react-measure";

var MeasureComponent = function (_React$Component) {
  _inherits(MeasureComponent, _React$Component);

  function MeasureComponent() {
    var _temp, _this, _ret;

    _classCallCheck(this, MeasureComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleScaleChange = function () {
      var _this$spacer = _this.spacer,
          clientWidth = _this$spacer.clientWidth,
          clientHeight = _this$spacer.clientHeight;

      _this.props.onSizeChange(clientWidth, clientHeight);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MeasureComponent.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(Measure, {
      bounds: true,
      onResize: function onResize() {
        return _this2.handleScaleChange();
      },
      innerRef: function innerRef(node) {
        _this2.spacer = node;
      }
    }, function (_ref) {
      var measureRef = _ref.measureRef;
      return React.createElement("div", {
        className: "video-measure",
        style: {
          width: "100%",
          height: "100%"
        },
        ref: measureRef
      });
    });
  };

  return MeasureComponent;
}(React.Component);

MeasureComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  onSizeChange: PropTypes.func.isRequired
} : {};
export default MeasureComponent;